import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import ButtonMenu from './ButtonMenu';
import Modal from './Modal'; 

import {TimelineLite, Sine} from 'gsap'

import '../../node_modules/parallax-js/deploy/parallax.js'


class Landing extends Component {

  constructor() {
    super();
    this.state = {
      scene: null,
      buttonMenu: [
        {
          label: "Tickets",
          target: "tickets"
        },
        {
          label: "Synopsis",
          target: "synopsisModal"
        },
        {
          label: "Characters",
          target: "characters"
        },
        {
          label: "Trailers",
          target: "trailersModal"
        },
        {
          label: "Gallery",
          target: "galleryModal"
        },
        {
          label: "Partners",
          target: "partners"
        }
      ]
    }
  }

  componentWillReceiveProps(nextProps){

    if(!this.props.showHeroes && nextProps.showHeroes){
      this.animateCharactersIn()
    }
  }

	componentWillAppear(callback){
		// console.log('landing component will appear')
		this.animateIn(callback)
	}

	componentDidAppear() {
		// console.log('landing component did appear')
	}

	componentWillEnter (callback) {
    // console.log('landing component will enter')
    this.animateIn(callback)
  }

  componentDidEnter () {
    // console.log('landing component entered')
  }

  componentWillLeave (callback) {
    // console.log('landing component will leave')
    const el = ReactDOM.findDOMNode(this)
    var tween = new TimelineLite({ onComplete: callback })

    tween.set(el, {
      opacity: 1,
    }).to(el, 0.4, {
      opacity: 0,
    })
  }

  componentDidLeave () {
    // console.log('landing component left')
    let parallax = this.state.scene
    parallax.disable();
    parallax = parallax.layers = parallax.element = undefined;
  }

  animateIn(callback) {
  	const el = ReactDOM.findDOMNode(this)
    var tween = new TimelineLite({ onComplete: callback })

    tween.set(el, {
      opacity: 0
    })
    .to(el, 1.2, {
      opacity: 1
    })
  }

  animateCharactersIn(){
    const el = ReactDOM.findDOMNode(this)
    var tween = new TimelineLite()
    const chars = el.querySelectorAll('.hero')
    
    tween.set(chars, {
      'opacity': 0,
      'y': '0.8%',
      scale: 0.99
    })
    .staggerTo(chars, 0.8, {
      'opacity': 1,
      'y': '0%',
      scale: 1,
      ease: Sine.easeInOut
    }, 0.32)
  }

  componentDidMount() {
    const el = ReactDOM.findDOMNode(this)
    const container = el.querySelector('.parallax-container')
    var parallax = new window.Parallax(container)
    this.setState({scene: parallax})
  }



  render() {
    return (
      <div className="landing">
        <div className="parallax-container">
          <div className="heroes-landing">
            <div className="layer hero starlord" data-depth="0.048"></div>
            <div className="layer hero gamora" data-depth="0.032"></div>
            <div className="layer hero drax" data-depth="0.016"></div>
            <div className="layer hero rocket" data-depth="0.036"></div>
            <div className="layer hero yondu" data-depth="0.016"></div>
            <div className="layer hero nebula" data-depth="0.01"></div>
            <div className="layer hero mantis" data-depth="0.01"></div>
          </div>

          <div className="layer layer-container" data-depth="0.008"><div className="tt-logo"></div></div>

          <div className="layer layer-container" data-depth="0.048">
            <ButtonMenu buttonMenu={this.state.buttonMenu} openModal={this.props.openModal.bind(this)} />
          </div>
        </div>
        <Modal activeModal={this.props.activeModal} closeModal={this.props.closeModal.bind(this)}/>
      </div>
    );
  }
}

export default Landing;


// WEBPACK FOOTER //
// ./src/Components/landing.js